import * as React from 'react'
import { Box, Typography } from '@material-ui/core'
import { useTranslate } from 'ra-core'

const placeholderGroups = [
  {
    titleKey: 'surveys.wscampaigns.url_help_user_title',
    items: [
      { token: '[ws_email]', descKey: 'surveys.wscampaigns.url_help_email' },
      { token: '[ws_name]', descKey: 'surveys.wscampaigns.url_help_name' },
      {
        token: '[ws_surname]',
        descKey: 'surveys.wscampaigns.url_help_surname',
      },
      { token: '[ws_phone]', descKey: 'surveys.wscampaigns.url_help_phone' },
      {
        token: '[ws_postalCode]',
        descKey: 'surveys.wscampaigns.url_help_postal_code',
      },
      { token: '[ws_gender]', descKey: 'surveys.wscampaigns.url_help_gender' },
      { token: '[ws_dbo]', descKey: 'surveys.wscampaigns.url_help_dob' },
      { token: '[ws_ip]', descKey: 'surveys.wscampaigns.url_help_ip' },
    ],
  },
  {
    titleKey: 'surveys.wscampaigns.url_help_questions_title',
    items: [
      {
        token: '[ws_{fieldMD}]',
        descKey: 'surveys.wscampaigns.url_help_questions_desc',
      },
    ],
  },
]

const WsCampaignUrlHelp = () => {
  const translate = useTranslate()

  return (
    <Box
      mb={2}
      p={2}
      bgcolor="grey.100"
      borderRadius={4}
      border="1px solid"
      borderColor="grey.300"
    >
      <Typography variant="subtitle2" gutterBottom>
        {translate('surveys.wscampaigns.url_help_title')}
      </Typography>
      <Typography variant="body2" color="textSecondary" paragraph>
        {translate('surveys.wscampaigns.url_help_intro')}
      </Typography>
      {placeholderGroups.map(group => (
        <Box key={group.titleKey} mb={1.5}>
          <Typography variant="body2" style={{ fontWeight: 600 }}>
            {translate(group.titleKey)}
          </Typography>
          {group.items.map(item => (
            <Typography
              key={item.token}
              variant="body2"
              color="textSecondary"
              component="div"
            >
              <code>{item.token}</code> — {translate(item.descKey)}
            </Typography>
          ))}
        </Box>
      ))}
      <Typography variant="caption" color="textSecondary" display="block">
        {translate('surveys.wscampaigns.url_help_example')}
      </Typography>
    </Box>
  )
}

export default WsCampaignUrlHelp
